import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/mediabook/mediabook/src/templates/Course.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Exercise = makeShortcode("Exercise");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Custom Calculator`}</h1>
    <p>{`It's time to put all of your Python skills together and write an interactive program that performs a
useful task! On the last page, you chose a custom calculator theme and calculation to perform
`}<span parentName="p" {...{
        "role": "img",
        "aria-label": "abacus"
      }}>{`🧮`}</span>{` Create your own custom calculator, and remember that if you get stuck, you can always look
at the snowboard calculator that we created in the video lesson as a guide.`}</p>
    <h2>{`Steps to Complete`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Write a comment at the top of this file explaining what your custom calculator will be
calculating.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Print an explanation for the user that tells them what your calculator does.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Use the built-in function `}<inlineCode parentName="p">{`input()`}</inlineCode>{` to prompt the user for the values that the calculator uses.
Remember to store them with descriptive variable names!`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Write the expression that uses the input values from your user and calculates a result.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Print out the result for the user. Remember to give details like the units of the value and
instructions on how to use it.`}</p>
      </li>
    </ol>
    <Exercise contentSrc="@makeschool2/T3-CustomCalculator" mdxType="Exercise" />
    <p>{`Congratulations on building an interactive Python program using the building blocks of computer
science! `}<span parentName="p" {...{
        "role": "img",
        "aria-label": "trophy"
      }}>{`🏆`}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      